import * as React from 'react';

function stripHtml(html?: string | null): string {
  if (!html) return '';
  return html
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]*>/g, '')
    .trim();
}

const Descriptions = React.memo((props: { value?: string | null }) => {
  const text = stripHtml(props.value);
  return (
    <div
      aria-label="Description"
      className="line-clamp-3 overflow-hidden pt-[5px] leading-tight"
      title={text || undefined}
    >
      {text || '--'}
    </div>
  );
});

Descriptions.displayName = 'Descriptions';

export default Descriptions;